const notFound = {
  title: 'पेज नहीं मिला',
  description: 'जिस पेज की आप तलाश कर रहे हैं वह मौजूद नहीं है या आपके पास इसकी पहुंच नहीं है।',
  goBack: 'वापस जाएं',
  home: 'होम',
};

export default notFound;